import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { usersApi } from '../services/api';
import './CreateUser.css';

function CreateUser({ user }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    emailAddress: '',
    firstName: '',
    lastName: '',
    userName: '',
    role: '',
    status: 'Active',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setError(null);

      // Get organization ID from logged-in user
      console.log('User object:', user);
      console.log('User profile:', user?.profile);

      // Try multiple possible field names
      const organisationId =
        user?.profile?.organisationId ||
        user?.profile?.organizationId ||
        user?.profile?.subscriptionId ||
        user?.profile?.subscription_id ||
        user?.organisationId ||
        user?.organizationId ||
        // Fallback to actual organization ID from database
        'df51816f-d87a-46df-97be-a5aa49e34fb6';

      console.log('Using organization ID:', organisationId);

      const userData = {
        ...formData,
        organisationId,
      };

      const createdUser = await usersApi.create(userData);

      // Navigate to the new user's profile
      navigate(`/users/${createdUser.id}`);
    } catch (err) {
      setError(err.message);
      console.error('Error creating user:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="create-user-container">
      <div className="form-header">
        <Link to="/users" className="back-link">
          ← Back to Users
        </Link>
        <h1>Create New User</h1>
        <p className="subtitle">Add a new user to your organization</p>
      </div>

      {error && (
        <div className="error-alert">
          <strong>Error:</strong> {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="user-form">
        <div className="form-section">
          <h2>Basic Information</h2>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">
                First Name <span className="required">*</span>
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="lastName">
                Last Name <span className="required">*</span>
              </label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="emailAddress">
              Email Address <span className="required">*</span>
            </label>
            <input
              type="email"
              id="emailAddress"
              name="emailAddress"
              value={formData.emailAddress}
              onChange={handleChange}
              required
              className="form-input"
              placeholder="user@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="userName">
              Username
            </label>
            <input
              type="text"
              id="userName"
              name="userName"
              value={formData.userName}
              onChange={handleChange}
              className="form-input"
            />
          </div>
        </div>

        <div className="form-section">
          <h2>Additional Details</h2>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="role">Role</label>
              <input
                type="text"
                id="role"
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="form-input"
                placeholder="e.g., Developer, Manager"
              />
            </div>

            <div className="form-group">
              <label htmlFor="status">
                Status <span className="required">*</span>
              </label>
              <select
                id="status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                required
                className="form-input"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                <option value="Pending">Pending</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate('/users')}
            className="btn btn-secondary"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Creating...' : 'Create User'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateUser;
